import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import dayjs from 'dayjs'
import { makeStyles } from '@material-ui/core'
import StatusPill from '../StatusPill'
import { isPublished } from './utils'

const useStyles = makeStyles({
  root: { marginTop: 16 },
  heading: { fontSize: 13, fontWeight: 600, color: '#0d0d0d', marginBottom: 8 },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    width: '100%',
    minWidth: 0,
    padding: '8px 0',
    border: 'none',
    borderBottom: '1px solid #eaeef6',
    backgroundColor: 'transparent',
    textAlign: 'left',
    font: 'inherit',
  },
  clickable: { cursor: 'pointer' },
  dot: { width: 8, height: 8, borderRadius: '50%', flexShrink: 0 },
  published: { backgroundColor: '#008e5b' },
  draft: { backgroundColor: '#7f889c' },
  name: {
    fontSize: 14,
    fontWeight: 600,
    color: '#0d0d0d',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flex: 1,
  },
  time: { fontSize: 12, color: '#686868', flexShrink: 0 },
})

const MobileDayList = ({ day, events, onEventClick }) => {
  const styles = useStyles()
  return (
    <div className={styles.root}>
      <div className={styles.heading}>{day.format('MMM D, YYYY')}</div>
      {events.map((event) => (
        <button
          key={event.id}
          type="button"
          className={clsx(styles.row, onEventClick && styles.clickable)}
          onClick={onEventClick ? () => onEventClick(event) : undefined}
        >
          <span className={clsx(styles.dot, isPublished(event.status) ? styles.published : styles.draft)} />
          <span className={styles.name}>{event.name}</span>
          <span className={styles.time}>
            {dayjs(event.startAt).format('h:mm A')} – {dayjs(event.endAt).format('h:mm A')}
          </span>
          <StatusPill status={event.status} />
        </button>
      ))}
    </div>
  )
}

MobileDayList.propTypes = {
  day: PropTypes.object.isRequired,
  events: PropTypes.array.isRequired,
  onEventClick: PropTypes.func,
}

MobileDayList.defaultProps = {
  onEventClick: undefined,
}

export default MobileDayList
